<template>
    <div class="app-wrapper">
        <el-container :key="$route.fullPath" direction="vertical">
            <page-header></page-header>
            <el-container class="max-main page-container" style="top: -70px;">
                <PageSidebarHelp :type="2" :menu-list="helpMenus"></PageSidebarHelp>
                <el-main class="page-main">
                    <router-view tag="main" />
                </el-main>
            </el-container>
        </el-container>
        <el-backtop></el-backtop>
    </div>
</template>

<script>
import PageHeader from './components/pageHeader';
import PageSidebarHelp from './components/pageSidebarHelp';

export default {
    components: { PageHeader, PageSidebarHelp },
    data() {
        return {};
    },
    computed: {
        helpMenus() {
            return (this.$store.state && this.$store.state.helpMenus) || [];
        }
    },
    created() {
        if (!this.helpMenus || this.helpMenus.length < 1) {
            this.getHelpMenus();
        }
    },
    methods: {
        getHelpMenus() {
            this.$store.dispatch('getHelpMenus');
        }
    }
};
</script>

<style lang="scss">
.el-container {
    min-height: 100vh;
}
</style>
